import axios from '../utils/axios'

const API_URL = `${process.env.REACT_APP_API_URL}/v1/client/`;

const getAppointment = (clinicId, date = 'today', ecpId) => {
    const params = new URLSearchParams({ date });
    if (ecpId) {
        params.set('ecpId', ecpId);
    }
    return axios.get(`${API_URL}clinics/${clinicId}/dashboard-appointments?${params.toString()}`);
};

const getDashboardStats = (clinicId) =>
    axios.get(`${API_URL}clinics/${clinicId}/dashboard-stats`);

const getDashboardCounts = (clinicId) =>
    axios.get(`${API_URL}clinics/${clinicId}/dashboard-counts`);

const dashboardService = {
    getAppointment,
    getDashboardStats,
    getDashboardCounts,
};

export default dashboardService;
